import { Injectable } from '@angular/core';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimWorkFlowItemStatusDropDownService {

  ClaimWorkFlowItemStatus : any = [
    {
      id: 0,
      value: 'Pending',
      class: 'pending'
    },
    // {
    //   id: 1,
    //   value: 'In Complete',
    //   class: 'incomplete'
    // },
    {
      id: 2,
      value: 'Completed',
      class: 'completed'
    },
  ]

  getClaimWorkFlowItemStatus() {
    return this.ClaimWorkFlowItemStatus;
  }

  getClaimWorkFlowItemStatusById(id : any) {
    return this.ClaimWorkFlowItemStatus.filter((x: any) => x.id == id);
  }

}
